<template>
  <div class="rounded-xl border border-red-200 bg-red-50/70 p-3 flex gap-2.5 items-start">
    <span class="w-8 h-8 rounded-lg bg-red-100 text-red-500 flex items-center justify-center flex-none">
      <i class="pi pi-times-circle text-sm" />
    </span>
    <div class="flex flex-col gap-1 min-w-0 flex-1">
      <div class="flex items-center gap-2 flex-wrap">
        <span class="text-[13px] font-semibold text-red-700">התור בוטל</span>
        <span class="text-[10.5px] px-1.5 py-0.5 rounded-full bg-white/80 text-red-600 border border-red-200">
          {{ sourceLabel }}
        </span>
      </div>

      <div class="flex items-center gap-1.5 text-[11.5px] text-red-900/70 flex-wrap">
        <template v-if="cancellation.cancelledByName">
          <i class="pi pi-user text-[10px]" />
          <span>{{ cancellation.cancelledByName }}</span>
          <span class="text-red-900/30">·</span>
        </template>
        <i class="pi pi-clock text-[10px]" />
        <span>{{ cancelledAtLabel }}</span>
      </div>

      <div
        v-if="cancellation.reason"
        class="mt-0.5 text-[12.5px] text-red-900 bg-white/70 border border-red-100 rounded-lg px-2.5 py-1.5 whitespace-pre-line break-words"
      >{{ cancellation.reason }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { AppointmentSource, type IAppointmentCancellation } from '@torim-app/types';
import { computed } from 'vue';
import { DateTime } from 'luxon';

const props = defineProps<{ cancellation: IAppointmentCancellation }>();

// Says at a glance whether the business or the customer cancelled — the distinction the
// owner actually cares about when looking back at a cancelled visit.
const SOURCE_LABELS: Partial<Record<AppointmentSource, string>> = {
  [AppointmentSource.ADMIN]: 'בוטל ע״י העסק',
  [AppointmentSource.ADMIN_BOT]: 'בוטל ע״י העסק (עוזר AI)',
  [AppointmentSource.BUSINESS_SITE]: 'בוטל ע״י הלקוח/ה באתר',
  [AppointmentSource.WHATSAPP_BOT]: 'בוטל ע״י הלקוח/ה בוואטסאפ',
};

const sourceLabel = computed(() => SOURCE_LABELS[props.cancellation.source] ?? 'בוטל');

const cancelledAtLabel = computed(() => {
  const dt = typeof props.cancellation.cancelledAt === 'string'
    ? DateTime.fromISO(props.cancellation.cancelledAt)
    : DateTime.fromJSDate(props.cancellation.cancelledAt as Date);
  if (!dt.isValid) return '';
  return dt.setLocale('he').toFormat('dd/LL/yyyy · HH:mm');
});
</script>

<style scoped lang="scss"></style>
